module.exports = __webpack_public_path__ + "img/Painel 4.61b49c98.jpg";